import { FaSyncAlt } from 'react-icons/fa';

const SearchAdvanceForm = ({ dateFields = [], additionalFields = [], onClear }) => {
  return (
    <div className="p-3 mt-4 border rounded-md bg-gray-50">
      <div className="grid grid-cols-1 gap-3 mb-3 sm:grid-cols-2 xl:grid-cols-5">
        {/* Tanggal: render per kolom, 1 untuk dari, 1 untuk sampai */}
        {dateFields.flatMap((field, index) => [
          <div key={`from-${index}`}>
            <label className="block mb-1 text-xs font-medium">{`Dari ${field.label}`}</label>
            <input
              type="date"
              value={field.fromValue}
              onChange={(e) => field.onFromChange(e.target.value)}
              className="w-full px-2 py-1.5 border text-sm rounded-md"
            />
          </div>,
          <div key={`to-${index}`}>
            <label className="block mb-1 text-xs font-medium">{`Sampai ${field.label}`}</label>
            <input
              type="date"
              value={field.toValue}
              onChange={(e) => field.onToChange(e.target.value)}
              className="w-full px-2 py-1.5 border text-sm rounded-md"
            />
          </div>
        ])}

        {/* Tambahan Field Lain */}
        {additionalFields.map((field, index) => (
          <div key={`additional-${index}`}>
            <label className="block mb-1 text-xs font-medium">{field.label}</label>
            <input
              type={field.type || 'text'}
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
              className="w-full px-2 py-1.5 border text-sm rounded-md"
            />
          </div>
        ))}
      </div>

      <div className="flex justify-end mt-2">
        <button
          onClick={onClear}
          className="inline-flex items-center text-xs font-medium text-red-500 hover:text-red-600 hover:underline"
          aria-label="Clear all filters"
        >
          <FaSyncAlt className="w-4 h-4 mr-1" />
          Clear All
        </button>
      </div>
    </div>
  );
};

export default SearchAdvanceForm;
